import PropTypes from 'prop-types';
import React from 'react';

import {ReactComponent as Check} from '../../assets/check.svg';
import SecondaryButton from '../../shared/SecondaryButton/SecondaryButton';
import { rmdDashboardLink } from '../../utils/constants';
import CloseIcon from '../SendConfirmationModal/CloseIcon';
import styles from './ComposeFAQ.module.scss';

const RMDModal = ({ closeModal, env }) => {

  return (
    <div className={styles['modal-container']}>
      <div className={`faq ${styles['rmd-modal-body']}`}>
        <a
          alt="close"
          className={styles['close-icon']}
          id="close-icon"
          onClick={closeModal}
        >
          <CloseIcon />
        </a>
        <div className={styles['faq-content']}>
          <div className={styles['rmd-faq-container']}>
            <div className={styles['rmd-faq-header-text']}>Visit Your RMD Dashboard</div>
            <div className={styles['rmd-faq-intro']}>You can:</div>
            <div className={styles['rmd-faq-list-item']}> <Check className={styles['rmd-faq-check']}/>View your RMD amount</div>
            <div className={styles['rmd-faq-list-item']}> <Check className={styles['rmd-faq-check']}/>Set up & edit your Auto-RMD</div>
            <div className={styles['rmd-faq-list-item']}> <Check className={styles['rmd-faq-check']}/>View your year-to-date IRA distribution amount</div>
            <div className={styles['rmd-faq-list-item']}> <Check className={styles['rmd-faq-check']}/>Update your tax withholding election for your automatic IRA withdrawal agreement</div>
            <div className={styles['rmd-faq-list-item']}> <Check className={styles['rmd-faq-check']}/>Take a Qualified Charitable Distribution (QCD)</div>
          </div>
        </div>
      </div>
      <div className={styles['button-container']}>
            <SecondaryButton
              className={`${styles['link-button']} close-modal`}
              onClick={() => {
                closeModal();
              }}
            >
              Continue With Message
            </SecondaryButton>
            <a className={styles['rmd-dashboard-button']}
               href={rmdDashboardLink[env]}
            >
              Visit RMD Dashboard
            </a>
          </div>
    </div>
  );
};

RMDModal.propTypes = {
  closeModal: PropTypes.func,
  env: PropTypes.string
};

export default RMDModal;
